import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import AppWrapper from "./Layout.style";
import Content from "../Content";
import FloatHeader from "../FloatHeader";
import { usePersistedState } from "../../hooks";
import useAuth from "../Authentication/useAuth";

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { rbacInfo } = useAuth();
  const [lastPath, setLastPath] = usePersistedState("LAST_PATHNAME", localStorage.getItem("LAST_PATHNAME"));
  const [isNewPath, setNewPath] = useState(false); // handle input URL from new or different page

  const mainUrl = rbacInfo
    .find((menu) => menu.has_access)?.sub_menus
    ?.find((subMenu) => subMenu.has_access)?.menu_url.slice(1);

  useEffect(() => {
    if (lastPath === "/" && mainUrl) navigate(mainUrl, { replace: true });
    else if (location.pathname !== lastPath) navigate(lastPath);
  }, [lastPath]);

  useEffect(() => {
    if (location.pathname !== "/" && location.pathname === lastPath && !isNewPath) {
      setLastPath(location.pathname);
      setNewPath(false);
    } else if (location.pathname !== "/" && location.pathname !== lastPath && !isNewPath) {
      setLastPath(location.pathname);
      setNewPath(true);
    }
  }, [location]);

  return (
    <AppWrapper>
      <FloatHeader />
      <Sidebar />
      <Content >
        <Outlet />
      </Content>
    </AppWrapper>
  );
}

export default Layout;
